import { render, staticRenderFns } from "./FullScreenAddVisitObject.vue?vue&type=template&id=61dfbc6b&scoped=true&"
import script from "./FullScreenAddVisitObject.vue?vue&type=script&lang=js&"
export * from "./FullScreenAddVisitObject.vue?vue&type=script&lang=js&"
import style0 from "./FullScreenAddVisitObject.vue?vue&type=style&index=0&id=61dfbc6b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dfbc6b",
  null
  
)

export default component.exports